module.exports = "<!-- <p>widget-loader works!</p> -->\r\n<div class=\"animated-background\">\r\n    \r\n</div>"